import { observer } from 'mobx-react-lite'
import { useOutletContext } from 'react-router'
import { type CallCenterViewModel } from '@/features/call-center/CallCenterViewModel'
import { JobSectionContainer } from '@/features/call-center/JobSection/JobSectionContainer'

export default observer(function CallCenterJobSectionPageContainer() {
  const vm = useOutletContext<CallCenterViewModel>()

  return <JobSectionContainer vm={vm.jobVm} />
})
